import {
  isProductVariant,
  Product,
  ProductSearchParams,
  SearchByShipAddress,
  SearchByShipLocation,
  SearchByShipState,
} from '../../api';
import { ProductApi } from '../../api/product/productApi';
import { calculateProductBundlePrice, defaultAddress } from '../../functions';
import { mapDeliveryExpectation } from '../../functions/deliveryExpectation/deliveryExpectation';

export class ProductService {
  private readonly productApi = new ProductApi();

  public async get(ids: string[], params: ProductSearchParams): Promise<Product[]> {
    const hasAddress =
      (params as SearchByShipAddress).shipAddress ||
      (params as SearchByShipLocation).latitude ||
      (params as SearchByShipState).shipState;
    const searchParams: ProductSearchParams = hasAddress
      ? params
      : {
          ...params,
          latitude: defaultAddress.latitude,
          longitude: defaultAddress.longitude,
          shipState: defaultAddress.state,
        };

    const products = await this.productApi.getProducts(ids, searchParams);

    if (!hasAddress && !ids.every((id) => id.includes('GIFTCARD'))) {
      Object.values(products).forEach((product) => (product.variants = []));
    }

    return this.mapProducts(products);
  }

  private mapProducts(products: Product[]): Product[] {
    if (!products) return products;

    Object.values(products).forEach((product) => {
      product.variants?.forEach((variant) => {
        if (!isProductVariant(variant)) return;

        variant.retailers = variant.retailers
          .sort((a) => (a.type === 'onDemand' ? -1 : a.type === 'engraved' ? 1 : 0))
          .map((retailer) => {
            retailer.shippingMethod = {
              ...retailer.shippingMethod,
              ...mapDeliveryExpectation({
                deliveryMethod: retailer.type,
                deliveryExpectation: retailer.shippingMethod.deliveryExpectation,
                customerPlacement: retailer.customerPlacement,
                preSale: variant.presale,
              }),
            };

            return retailer;
          });
      });

      product.isBundle = !!product.bundleConfigs;
      if (product.isBundle) {
        product.price = calculateProductBundlePrice(product);
      }
    });

    return products;
  }
}
